import React, { useState, useEffect } from 'react';
import './css/Order.css';
import { firestore } from '../firebase';
import numeral from 'numeral';
import { LocationOn, Phone } from '@mui/icons-material';

function Order({ data }) {
  const [statusFilter, setStatusFilter] = useState('');
  const [userAddress, setUserAddress] = useState('');

  useEffect(() => {
    const updateOrderStatus = async () => {
      try {
        if (data?.name && statusFilter !== '') {
          const orderId = `${data.name}_${data.orderId || ''}`;
          const orderRef = firestore.collection('orders').doc(orderId);

          await orderRef.update({ status: statusFilter });
        }
      } catch (error) {
        console.error('Error updating status:', error);
      }
    };

    updateOrderStatus();
  }, [statusFilter, data]);

  const date = data?.orderDate?.toDate();
  const orderDate = date?.toLocaleDateString();

  useEffect(() => {
    const getAddressData = async () => {
      try {
        const addressDoc = await firestore.collection('customers').doc(data?.name).get();

        if (addressDoc.exists) {
          const addressData = addressDoc.data();
          setUserAddress(addressData?.address || 'No address found');
        } else {
          console.log('Document not found');
        }
      } catch (error) {
        console.error('Error fetching address:', error);
      }
    };
    getAddressData();
  }, [data?.name]);

  const addressShow = (e) => {
    alert(`Delivery Address of ${data?.name} is ${userAddress}`);
  };

  return (
    <div className='order'>
      <p>{data?.name}</p>
      <p>{data?.method}</p>
      <p>${data?.price}</p>
      <p>{orderDate}</p>
      <a href={`/product-detail/${data?.itemOrdered}`}>
        <p style={{ textDecoration: 'underline', cursor: 'pointer' }}>Ordered This</p>
      </a>
      <p>{data?.status || 'Status'}</p>
      {data?.status !== 'Canceled' && (
        <p>
          <select onChange={(e) => setStatusFilter(e.target.value)} style={{ marginRight: '10px' }}>
            <option value=''>Action</option>
            <option value='Delivered'>Delivered</option>
            <option value='Pending'>Pending</option>
            <option value='Canceled'>Canceled</option>
          </select>
        </p>
      )}
      <p onClick={addressShow}>
        <LocationOn />
      </p>
    </div>
  );
}

export default Order;
